import apiResponse from '@stores/ApiResponse';
import { QuestionnaireAdminStore, QuestionnaireScheduleDefinition } from '@stores/QuestionnaireAdminStore';
import actionResponse, { ActionResponse } from '@actions/ActionResponse';
import { questionnaireActionError } from './questionnaireActionError';

/**
 * Creates a schedule, or edits one when given its id. On failure the status message is the server's explanation,
 * e.g. that a schedule a cohort uses can only be renamed.
 */
export class SaveQuestionnaireScheduleAction {
  constructor(private readonly store: QuestionnaireAdminStore = new QuestionnaireAdminStore()) {}

  public async Execute(
    scheduleId: number | null,
    definition: QuestionnaireScheduleDefinition
  ): Promise<ActionResponse> {
    try {
      if (scheduleId) {
        await apiResponse.handleApiResponse(() => this.store.UpdateSchedule(scheduleId, definition));
        return actionResponse.Success('Schedule saved');
      }
      const created = await apiResponse.handleApiResponse(() => this.store.CreateSchedule(definition));
      return actionResponse.Success('Schedule created', created);
    } catch (err) {
      return questionnaireActionError(err);
    }
  }
}
